import { parseDate as parse } from '../Utils/date';
import { findRule } from '../Utils';

const validate = (vObj) => {
  const value = vObj.value ? vObj.value : '';
  const rule = findRule(vObj.errorBag, 'date_format');
  const format = rule.ruleParams;

  rule.feedback = `${vObj.fieldlabel} is required to be in ${format} format`;

  return !!parse(value, format, new Date());
};

export { validate };

export default {
  validate,
};
